import type { SVGProps } from 'react';
const SvgPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 6a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1 0-1.5h10.5A.75.75 0 0 1 12 6Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 0a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 6 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPlus;
